import { Store } from "./store";

export class AppleWalletPreferences {
	venueKey: number;
	walletType: number;
	organizationName: string;
	descriptionText: string;
	secondaryText: string;
	logoText: string;
	balanceLabel: string;
	foregroundColor: string;
	backgroundColor: string;
	labelColor: string;
	created: Date;
	modified: Date;

	foreground: { r: number; g: number; b: number };
	background: { r: number; g: number; b: number };
	foregroundHex: string;
	backgroundHex: string;

	Venue: Store;

	public constructor(init?: Partial<AppleWalletPreferences>) {
		Object.assign(this, init);
	}

	static parseColor(color: string) {
		let c = color.replace("rgb(", "");
		c = c.replace(")", "");
		const cAry = c.split(",");
		return {
			r: +cAry[0],
			g: +cAry[1],
			b: +cAry[2],
		};
	}

	static fromPrimeNgColor(colors: { r: number; g: number; b: number }): string {
		return `rgb(${colors.r}, ${colors.g}, ${colors.b})`;
	}
}
